import * as React from "react";

import { Container } from "semantic-ui-react";

import { AllGenericCaseTypes } from "./AllGenericCaseTypes";
import { GenericCaseTypeDetails } from "./GenericCaseTypeDetails";

import { Fragment } from "redux-little-router";

const GenericCaseTypesBase: React.FunctionComponent = () => {
    return (
        <Container>
            <Fragment forRoute="/:genericCaseTypeId" withConditions={l => l.params.genericCaseTypeId !== undefined}>
                <GenericCaseTypeDetails />
            </Fragment>
            <Fragment forNoMatch>
                <AllGenericCaseTypes />
            </Fragment>
        </Container>
    );
};

export { GenericCaseTypesBase };
